import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RedirectService {
  private readonly REDIRECT_URL_KEY = 'redirectUrl';

  /**
   * Store the URL to redirect to after login
   */
  setRedirectUrl(url: string): void {
    if (
      url &&
      url !== '/login' &&
      url !== '/' &&
      url !== '/register' &&
      url !== '/forgot-password'
    ) {
      localStorage.setItem(this.REDIRECT_URL_KEY, url);
    }
  }

  /**
   * Get the stored redirect URL
   */
  getRedirectUrl(): string | null {
    return localStorage.getItem(this.REDIRECT_URL_KEY);
  }

  /**
   * Clear the stored redirect URL
   */
  clearRedirectUrl(): void {
    localStorage.removeItem(this.REDIRECT_URL_KEY);
  }

  /**
   * Get and clear the redirect URL in one operation
   */
  getAndClearRedirectUrl(): string | null {
    const url = this.getRedirectUrl();
    this.clearRedirectUrl();
    return url;
  }

  /**
   * Check if there's a valid redirect URL stored
   */
  hasRedirectUrl(): boolean {
    const url = this.getRedirectUrl();
    return !!(
      url &&
      url !== '/login' &&
      url !== '/' &&
      url !== '/register' &&
      url !== '/forgot-password'
    );
  }
}
